import React, { useState } from 'react';
import theme, { getTheme } from '../../theme';
import { useDarkMode } from '../../context/DarkModeContext';

const SIZES = {
  xs: { padding: '5px 10px', fontSize: '11px', borderRadius: '8px', minHeight: '28px' },
  sm: { padding: '7px 14px', fontSize: '12px', borderRadius: '10px', minHeight: '34px' },
  md: { padding: '10px 20px', fontSize: '13px', borderRadius: '10px', minHeight: `${theme.minTapTarget}px` },
  lg: { padding: '13px 26px', fontSize: '14px', borderRadius: '12px', minHeight: '50px' },
};

export default function Button({ variant = 'primary', size = 'md', children, style, disabled, ...rest }) {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);
  const [focused, setFocused] = useState(false);
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);

  const VARIANTS = {
    primary: {
      background: 'linear-gradient(135deg, #d4a843 0%, #b8872d 100%)',
      color: '#0e0c0a',
      border: 'none',
      boxShadow: '0 4px 14px rgba(212,168,67,0.25)',
    },
    secondary: {
      background: t.surface2,
      color: t.text,
      border: `1px solid ${t.border2}`,
    },
    ghost: {
      background: 'transparent',
      color: t.textSec,
      border: `1px solid ${t.border2}`,
    },
    dark: {
      background: t.surface2,
      color: t.text,
      border: `1px solid ${t.border2}`,
      boxShadow: t.shadow1,
    },
    danger: {
      background: 'rgba(224,82,82,0.08)',
      color: t.red,
      border: `1px solid rgba(224,82,82,0.2)`,
    },
    purple: {
      background: 'linear-gradient(135deg, #8b6fd4 0%, #6b52a8 100%)',
      color: 'white',
      border: 'none',
      boxShadow: '0 4px 14px rgba(139,111,212,0.3)',
    },
  };

  const v = VARIANTS[variant] || VARIANTS.primary;
  const s = SIZES[size] || SIZES.md;
  const focusRing = variant === 'purple' ? theme.focusRingPurple : theme.focusRing;
  return (
    <button
      disabled={disabled}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setActive(false); }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      style={{
        ...v, ...s,
        fontWeight: 700,
        fontFamily: theme.fontBody,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s ease',
        outline: 'none',
        transform: active && !disabled ? 'scale(0.98)' : (hovered && !disabled ? 'translateY(-1px)' : 'none'),
        boxShadow: focused ? focusRing : hovered && !disabled && v.boxShadow ? v.boxShadow : v.boxShadow,
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
